import {useState} from "react";

import styles from './Login.module.css';
import {IAM_PATH} from "../../utils/Config";
import axios from "../../utils/api/axios";
import {useNavigate} from "react-router-dom";
import {DialogEnum, showDialog} from "../../utils/dialog/Dialog";


/**
 * 로그인 화면
 * @returns {JSX.Element}
 * @constructor
 */
function Login() {
    
    const movePage = useNavigate();
    
    const [isHiddenFail, setIsHiddenFail] = useState(true);

    const [inputs, setInputs] = useState({
        id: '',
        password: ''
    });    

    const onChange = (e) => {
        const {value, name} = e.target;
        setInputs({
            ...inputs,
            [name]: value
        });
    };

    const handleEnter = (e) => {
        if (e.key === "Enter") {
            e.target.blur();
            onClickLogin();
        }
    };

    // 로그인 API
    const onClickLogin = () => {
        if (!inputs.id || !inputs.password) {
            setIsHiddenFail(false);
        } else {
            setIsHiddenFail(true);
        }

        const params = {
            userId: inputs.id,
            password: inputs.password
        }

        if (inputs.id && inputs.password) {
            const url = IAM_PATH + "/rest/login";
            
            axios.post(url, params)
            .then(res => {
                if(res.data.code == 200){
                    sessionStorage.setItem("id", res.data.data.id);
                    sessionStorage.setItem("userId", res.data.data.userId);
                    sessionStorage.setItem("userName", res.data.data.userName);
                    sessionStorage.setItem("groupId", res.data.data.groupId);
                    sessionStorage.setItem("groupName", res.data.data.groupName);
                    sessionStorage.setItem("apikey", res.data.data.apikey);
                    sessionStorage.setItem("role", res.data.data.role);
                    showDialog(DialogEnum.SUCCESS, "로그인 성공", res.data.data.userName + " 님 어서오세요.", movePage('/dashboard'));
                }else {
                    showDialog(DialogEnum.FAIL, "로그인 실패", res.data.message);
                }
            })
            .catch((e) => {
                console.error(e);
                showDialog(DialogEnum.DEFAULT, "로그인 실패", e);
            })
        }
    }

    const onClickRegist = () => {

    }

    return (
        <div className={styles.login}>
            {/* <h1 className={styles.login__title}>고객관리 시스템</h1> */}
            <div className={styles.login__logo}></div>
            <div className={styles.login__content}>
                {/* <div className={styles.login__left}> */}
                {/* </div> */}

                <div className={styles.login__box}>
                <h2 className={styles.login__label}>로그인</h2>
                <p className={styles.login__desc}>서비스를 이용하시려면 로그인을 해주십시오.</p>

                <input
                    className={styles.login__input}
                    name="id"
                    type="text"
                    value={inputs.id}
                    onChange={onChange}
                    placeholder="아이디"
                />

                <input
                    className={styles.login__input}
                    name="password"
                    type="password"
                    value={inputs.password}
                    onChange={onChange}
                    placeholder="비밀번호"
                    onKeyDown={handleEnter}
                    required
                />

                {!isHiddenFail && (
                    <div className={styles.login__warning_text}>
                    관리자 정보 또는 패스워드를 입력해 주세요.
                    </div>
                )}

                <button className={styles.login__btn} onClick={onClickLogin}>
                    Log in
                </button>
                {/* <button className={styles.regist__btn} onClick={onClickRegist}>
                    회원가입
                </button> */}
                </div>
            </div>

            <p className={styles.login__copy}>ⓒ 2025. adduce. All rights reserved.</p>
        </div>


    )

}

export default Login;